export const variantMuiButton = {
  MuiButton: {
    variants: [
      {
        props: { color: "blueBright", variant: "contained" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.primary.blueBright,
          color: theme.palette.common.white,
          "&:hover": {
            backgroundColor: theme.palette.primary.blueBright,
            opacity: 0.9,
          },
        }),
      },
      {
        props: { color: "purple", variant: "contained" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.purple.deep,
          color: theme.palette.common.white,
          "&:hover": {
            backgroundColor: theme.palette.purple.bright,
          },
        }),
      },
      {
        props: { color: "blueBright", variant: "outlined" },
        style: ({ theme }) => ({
          color: theme.palette.primary.blueBright,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.primary.blueBright}`,
          "&:hover": {
            backgroundColor: theme.palette.primary.blueBrightBg,
            border: `1px solid ${theme.palette.primary.blueBright}`,
          },
        }),
      },
      {
        props: { color: "purple", variant: "outlined" },
        style: ({ theme }) => ({
          color: theme.palette.purple.deep,
          border: `1px solid ${theme.palette.purple.deep}`,
          "&:hover": {
            backgroundColor: theme.palette.purple.pale,
            border: `1px solid ${theme.palette.purple.deep}`,
          },
        }),
      },
    ],
  },
}
